import Vue from 'vue'
import Vuex from 'vuex'
import global from './global'
import user from './user'
import vagas from './vagas'
import google from './google'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    global,
    user,
    vagas,
    google
  },
  plugins: [createPersistedState({
    paths: ['global'],
  })]
})

export default store;
